import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { apiClient } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const match = window.location.hash.match(/session_id=([^&]+)/);
        const sessionId = match ? match[1] : null;

        const finish = (user) => {
            window.history.replaceState(null, "", window.location.pathname);
            navigate("/my-orders", { replace: true, state: user ? { user } : undefined });
        };

        if (!sessionId) {
            finish(null);
            return;
        }

        apiClient
            .post("/auth/session", { session_id: sessionId })
            .then(({ data }) => {
                setUser(data);
                finish(data);
            })
            .catch(() => finish(null));
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--sss-bg)" }} data-testid="auth-callback">
            <div className="text-center">
                <Loader2 size={32} className="animate-spin text-[var(--sss-pink)] mx-auto" />
                <p className="mt-4 text-sm text-[var(--sss-text-muted)]">Signing you in…</p>
            </div>
        </div>
    );
}
